import { Injectable, NgModule } from '@angular/core';
import { FeatureToggles } from './feature-toggle.service';

@Injectable()
export class MockFeatureToggleService {
  private featureToggles: FeatureToggles = {
    enableAlertsAndNotifications: false,
    enableApiForNettedCollections: false,
    enableFifteenDayAlertsAndNotifications: false,
    enableQuickActions: false,
    showPayInfoPrintButtonAndNotesColumn: false,
    achReversalCutOffESTTimeZone: true,
    enableDefaultPayDate: false,
    enableStopPaymentRequest: false,
    enablePendo: false,
    enableHomeAlertsNotifications: false,
    enableAlertDetailsNachaAuditInfo: false,
    enableEEPDetailedWebAccessRights: false,
    enableCUIUnifiedNavigation: false,
    enablePrenoteAlertsNotifications: false,
    eEPayPSGAlertUpdates: false,
    enableEePayAssemblingStatus: false,
    enableStopPaymentInfoBox: false,
    enableStaleDatedChecks: false,
    enableSendPrenoteFile: false,
    enableUltiProExternalHandler: false,
  };

  public isFeatureEnabled(feature: (keyof FeatureToggles)): boolean {
    return this.featureToggles[feature];
  }

  setIsFeatureEnabled(feature: (keyof FeatureToggles), isEnabled: boolean) {
    this.featureToggles[feature] = isEnabled;
  }

  init(toggles: FeatureToggles) {
    this.featureToggles = toggles;
  }
}

@NgModule({
  providers: [MockFeatureToggleService],
})
export class MockFeatureToggleModule {
}
